import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ThunderFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.04 8.98001C18.76 8.57001 18.29 8.36001 17.8 8.44001L13.76 9.11001V2.71001C13.76 2.28001 13.48 1.91001 13.07 1.80001C12.66 1.68001 12.23 1.85001 12 2.22001L4.94998 13.68C4.68998 14.1 4.69998 14.62 4.97998 15.03C5.25998 15.44 5.72998 15.65 6.21998 15.57L10.26 14.9V21.31C10.26 21.74 10.54 22.11 10.95 22.23C11.04 22.25 11.13 22.27 11.21 22.27C11.53 22.27 11.84 22.1 12.01 21.82L19.06 10.36C19.32 9.94001 19.31 9.42001 19.03 9.01001L19.04 8.98001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ThunderFilledIcon.displayName = 'ThunderFilledIcon';
